import React, { useEffect, useRef, useState } from "react"
import {
  Card,
  CardBody,
  Container,
  Button,
  Modal,
  ModalBody,
  ModalHeader,
  Label,
  Input,
  Row,
  Col,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  ModalFooter,
  FormGroup,
  Table,
} from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { withTranslation } from "react-i18next"
import {
  FaFile,
  FaFileAlt,
  FaFileImport,
  FaFilter,
  FaPlus,
  FaSave,
  FaTruck,
  FaUsers,
} from "react-icons/fa"
import {
  MdCancel,
  MdCurrencyPound,
  MdDiamond,
  MdImportExport,
  MdRemove,
  MdReport,
} from "react-icons/md"
import Loader from "components/Loader/loader"
import WelcomeComp from "./WelcomeComp"
import {
  FaDiamond,
  FaFileCircleCheck,
  FaFileCircleExclamation,
  FaFileCircleXmark,
} from "react-icons/fa6"
import { fetchData } from "utils/Common_api_functions"
import moment from "moment"

const Dashboard = () => {
  const [loading, setLoading] = useState(false)

  const [data, setData] = useState({})

  useEffect(() => {
    fetchDashboardData()
  }, [])

  async function fetchDashboardData() {
    const APIdata = await fetchData(setLoading, "dashboard")
    if (APIdata?.success) {
      setData(APIdata?.data)
    }
  }

  return (
    <React.Fragment>
      {loading && <Loader />}

      <div className="page-content">
        <Row className="mt-4 mb-5">
          <Col xl={3}>
            <WelcomeComp />
          </Col>

          <Col xl={9}>
            <Row className="align-items-center h-100">
              <Col md="4">
                <Card className="mini-stats-wid mb-3 shadow-lg">
                  <CardBody className="d-flex align-items-center justify-content-between p-3">
                    <div>
                      <h3 className="mb-2 fw-bold">{data?.products}</h3>
                      <h6>Total Product</h6>
                    </div>
                    <div className="avatar-sm rounded-circle mini-stat-icon">
                      <span className="avatar-title rounded-circle">
                        <MdDiamond fontSize={24} />
                      </span>
                    </div>
                  </CardBody>
                </Card>
              </Col>
              <Col md="4">
                <Card className="mini-stats-wid mb-3 shadow-lg">
                  <CardBody className="d-flex align-items-center justify-content-between p-3">
                    <div>
                      <h3 className="mb-2 fw-bold">{data?.vendors}</h3>
                      <h6>Total Vendor</h6>
                    </div>
                    <div className="avatar-sm rounded-circle mini-stat-icon">
                      <span className="avatar-title rounded-circle">
                        <FaTruck fontSize={24} />
                      </span>
                    </div>
                  </CardBody>
                </Card>
              </Col>
              <Col md="4">
                <Card className="mini-stats-wid mb-3 shadow-lg">
                  <CardBody className="d-flex align-items-center justify-content-between p-3">
                    <div>
                      <h3 className="mb-2 fw-bold">{data?.staff}</h3>
                      <h6>Total Staff</h6>
                    </div>
                    <div className="avatar-sm rounded-circle mini-stat-icon">
                      <span className="avatar-title rounded-circle">
                        <FaUsers fontSize={24} />
                      </span>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col xl={8}>
            <Card>
              <CardBody>
                <h4 className="fw-bold text-black mb-4">Recent 5 Uploads</h4>
                <Table striped bordered>
                  <thead className="table-blue">
                    <tr>
                      <td>#</td>
                      <td>Date</td>
                      <td>FileName</td>
                      <td>Invoice No / Memo No</td>
                      <td>Vendor</td>
                      <td>Amount</td>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.last_5_invoices?.map((item, index) => (
                      <tr key={index}>
                        <td>{index + 1}.</td>
                        <td>{moment(item?.createdAt).format("MM-DD-YYYY")}</td>
                        <td>{item.invoiceLink?.split("/")?.[1]}</td>
                        <td>
                          {item?.invoiceNo !== "null"
                            ? item?.invoiceNo
                            : item?.memoNo}
                        </td>
                        <td>{item?.vendor?.company}</td>
                        <td>$ {item?.totalAmount}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Col>
          <Col xl={4}>
            <Card>
              <CardBody>
                <h4 className="fw-bold text-black mb-4">Latest Vendors</h4>
                <Table striped bordered>
                  <thead className="table-blue">
                    <tr>
                      <td>#</td>
                      <td>Vendor Name</td>
                      <td>Contact Person</td>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.last_5_vendors?.map((item, index) => (
                      <tr key={index}>
                        <td>{index + 1}.</td>
                        <td>{item?.company}</td>
                        <td>{item?.name}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  )
}

export default withTranslation()(Dashboard)
